export function clearIconActiveColorPanel(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.removeProperty('--iconActiveColorPanel');
}
